<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'cardover',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <div class="flex-column" v-if="device=='mobile'" :style="{height:(data.child.length+1)*120+'px'}">
          <div @click="change(i)" :class="i==activeIndex?'active box-shadow':''" class="content-box flex-column align-center justify-center" v-for="(item,i) in data.child" :key="i" :style="{backgroundImage:'url('+addip(item.pic)+')',height:'auto'}">
              <h3 >{{ item.name }}</h3>
              <h5 >{{ item.sub }}</h5>
          </div>
      </div>
      <div class="flex" v-else>
          <div  @click="change(i)" :class="i==activeIndex?'active  box-shadow':''" class="content-box flex-column align-center justify-center" v-for="(item,i) in data.child" :key="i" :style="{backgroundImage:'url('+addip(item.pic)+')',width:'164px'}">
              <h3 style="">{{ item.name }}</h3>
              <h5 >{{ item.sub }}</h5>
          </div>
      </div>
    </div>
</template>
<script setup lang="ts" name="cardover">
import {defineComponent,defineProps,onMounted,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
import useSiteSettings from '@/store/useSiteSettings'
const {  device } = useSiteSettings()
const props=defineProps({
  data:Object
})
const handerin=ref<Boolean>(false)
const plus=ref<Boolean>(true)
const activeIndex=ref<Number>(0)
const change=(i)=>{
  activeIndex.value=i
  handerin.value=true

  setTimeout(()=>{
      handerin.value=false
      timeout()
    },10000)
}
const timeout=()=>{
  if(handerin.value==false){
    if(activeIndex.value==props.data.child.length-1){
      plus.value=false
    }
    if(activeIndex.value==0){
      plus.value=true
    }
    if(plus.value){
    activeIndex.value++
    }else{
    activeIndex.value--
    }
    setTimeout(timeout,5000)
  }
}
onMounted(()=>{
  setTimeout(timeout,2000)
})
</script>
<style lang="less">
    .cardover{
      .content-box{
        cursor: pointer;min-height: 120px;
        height: 400px;overflow: hidden;transition: all .2s linear;
        h5{display: none;}
      }
      .content-box.active{
        flex:1;
        h5{display: block;}
      }
    }
</style>
